import type { LegalLink } from '../types/content'

export const siteConfig = {
  brandName: 'Punniken met Liefde',
  descriptor: 'Digitale handleiding met sjablonen',
  price: '€ 24,95',
  /** Vorige prijs per bonus, doorgestreept getoond. */
  bonusOriginalPrice: '€ 10',

  pageTitle: 'Punniken met Liefde | Digitale handleiding met sjablonen',
  pageDescription:
    'Maak zelf namen, decoraties en persoonlijke cadeaus met punnikkoord. Een praktische handleiding, een verzameling sjablonen en vier bonussen. Dit is een digitaal product. Je ontvangt geen fysieke materialen.',

  /** Betaallink van de koopknop in de sectie #pakket. */
  checkoutUrl: 'https://punniken-met-liefde.impultienda.ar/checkout/punniken-met-liefde',

  /**
   * Presentatievideo (staand kader 4:5).
   * Niet afspeelbaar = tekstuele tijdelijke weergave.
   */
  heroVideoUrl: 'https://cdn.magicpatterns.com/uploads/1o86kEsNfcqwYK1XKr7ga3/IMG_8081.mov',

  /** Meta Pixel van Punniken met Liefde. */
  metaPixelId: '1602408164970427',

  /** Tekst van de ronde badge op de video. */
  heroBadge: { value: '+300', label: 'sjablonen' },

  /**
   * Beoordelingslabel in de hero. Niet bevestigd: wordt niet getoond.
   */
  trust: {
    rating: 4.9,
    customerLabel: 'Meer dan 1.500 vrouwen zijn al aan het creëren',
    confirmed: true,
  },

  /** FAQ-antwoorden die wachten op bevestigde voorwaarden. Leeg = vraag verborgen. */
  deliveryAnswer: '',
  commercialUseAnswer: '',
  refundAnswer: '',

  /** Footerlinks. Alleen links met een echte URL worden getoond. */
  legalLinks: [
    { label: 'Contact', href: '' },
    { label: 'Algemene voorwaarden', href: '' },
    { label: 'Privacyverklaring', href: '' },
    { label: 'Digitale inhoud en herroepingsrecht', href: '' },
  ] as LegalLink[],
}
